import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./css/ServiceDetail.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const resolveImageUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  if (src.startsWith("/uploads/")) return `${API_BASE_URL}${src}`;
  return src;
};

const ServiceDetail = () => {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [allServices, setAllServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [detailRes, listRes] = await Promise.all([
          fetch(`${API_BASE_URL}/api/services/${id}`),
          fetch(`${API_BASE_URL}/api/services`),
        ]);

        if (detailRes.ok) {
          const detailData = await detailRes.json();
          setService(detailData.service || null);
        } else {
          setService(null);
        }

        if (listRes.ok) {
          const listData = await listRes.json();
          setAllServices(Array.isArray(listData.services) ? listData.services : []);
        } else {
          setAllServices([]);
        }
      } catch {
        setService(null);
        setAllServices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return <div className="text-center py-5">جاري تحميل تفاصيل الخدمة...</div>;
  }

  if (!service) {
    return <div className="text-center py-5">الخدمة غير موجودة</div>;
  }

  const features = Array.isArray(service.features) ? service.features : [];

  return (
    <>
      {/* 1. Header Section */}
      <div className="page-header">
        <div className="container">
          <h1>{service.title}</h1>
          <div className="breadcrumb">
            الرئيسية / خدماتنا / {service.title}
          </div>
        </div>
      </div>

      {/* 2. Main Content Section */}
      <section className="service-detail-section">
        <div className="container">
          <div className="row">
            {/* Sidebar (Navigation) */}
            <div className="col-lg-4 col-md-12">
              <aside className="service-sidebar">
                <h3>خدماتنا</h3>
                <ul className="service-list">
                  {allServices.map((item) => (
                    <li key={item.id}>
                      <Link
                        to={`/service/${item.id}`}
                        className={`service-link ${item.id === service.id ? "active" : ""}`}
                      >
                        {item.title}
                        <i className="fa-solid fa-angle-left float-end mt-1"></i>
                      </Link>
                    </li>
                  ))}
                </ul>

                <div className="sidebar-contact">
                  <h4>هل تحتاج مساعدة من نبض كير؟</h4>
                  <p>تواصل معنا في نبض كير الآن للحصول على استشارة مجانية لمشروعك.</p>
                  <Link to="/contact" className="sidebar-contact-btn">
                    تواصل معنا
                  </Link>
                </div>
              </aside>
            </div>

            {/* Main Details Area */}
            <div className="col-lg-8 col-md-12">
              <div className="service-main-content">
                {service.image && (
                  <img
                    src={resolveImageUrl(service.image)}
                    alt={service.title}
                    className="service-main-image"
                  />
                )}

                <h2>نظرة عامة على الخدمة</h2>
                <p className="service-desc">{service.fullDesc}</p>

                {features.length > 0 && (
                  <>
                    <h2>ماذا نقدم في هذه الخدمة؟</h2>
                    <div className="service-features-grid">
                      {features.map((feature, index) => (
                        <div className="feature-box" key={index}>
                          <i className="fa-solid fa-circle-check"></i>
                          <p>{feature}</p>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceDetail;